module.exports = __webpack_public_path__ + "af1ad4cf2fab13c8ae0eff4c51359c4c.jpg";